<template>
  <div class="all-style-bgc">
    <div class="container">
      <div class="title-tab">
        <span>当前位置：</span>
        <span @click="GoreportInternet">审查调查></span>
        <span @click="GoreportEvaluation">党纪政务处分></span>
        <span class="red">正文</span>
      </div>
      <!--正文内容-->
      <div class="text">
        <h1>河南省政府原党组成员、副省长徐光严重违纪违法被开除党籍和公职</h1>
        <div class="first">
        <span class="third">来源：新华社</span>
         <span class="si">|</span>
        <span>发布时间：2020-5-20 13:30</span>
      </div>
      <div class="xh"></div>
        <h3 class="yi">日前，经中共中央批准，中央纪委国家监委对河南省政府原党组成员、副省长徐光严重违纪违法问题进行了立案审查调查。</h3>
        <h3>经查，徐光丧失理想信念，背弃初心使命，对党不忠诚不老实，对抗组织审查，沉迷于迷信活动；违反中央八项规定精神，多次接受可能影响公正执行公务的宴请，长期无偿使用管理和服务对象的车辆；在组织函询时，不如实向组织说明问题；违规收受礼金、消费卡；同不法企业主大搞权钱交易，将公权力作为谋取私利的工具，在职务调整晋升、企业经营、案件处理等方面利用职务上的便利为他人谋利，并非法收受巨额财物。.11%。从村（社区）干部受处理具体案例来分析，两人或两人以上“抱团”违纪现象比较普遍。主要表现为以村支部书记、主任为核心，其他村组干部参与、共同“谋划”的利益“小团体”，成为违纪违法问题的高危群体。如，该市太平镇崔垱村、大王村从村支部书记到村委会委员，集体挪用粮食直补款、坐收坐支集体资金等，涉及村“两委”干部达5人。+体会交流+廉政党课”的方式召开了“一案一教育”警示教育大会，强化警示教育的感染力和说服力。</h3>
        <h3>徐光严重违反党的政治纪律、组织纪律、廉洁纪律和生活纪律，构成严重职务违法并涉嫌受贿犯罪，且在党的十八大后不收敛、不收手，对任职地区的政治生态造成恶劣影响，应予严肃处理。依据《中国共产党纪律处分条例》《中华人民共和国监察法》等有关规定，经中央纪委常委会会议研究并报中共中央批准，决定给予徐光开除党籍处分；由国家监委给予其开除公职处分；终止其河南省第十次党代会代表资格；收缴其违纪违法所得；将其涉嫌犯罪问题移送检察机关依法审查起诉，所涉财物随案移送。-2018年在担任该所党支部书记、所长期间，违反中央八项规定精神、违反政治纪律、挪用公款、非法占有公共财物等，被群众多次举报。其中违反中央八项规定精神达3次之多，从党内警告处分直至给予留党察看。分析多次被举报受处分人员情况，国家工作人员71人，农村党员干部108人。其中村（社区）主职干部被举报频率较高，受处分达72人，占比40.22%。</h3>
        <h3>
          <b>徐光简历</b>
        </h3>
        <h3>徐光，男，1960年6月生，汉族，湖北当阳人，在职研究生学历，天津大学经济系研究生毕业，1984年6月加入中国共产党，1977年8月参加工作。</h3>
        <h3>1977.08—1979.09，河南省鹤壁市石林公社下乡；</h3>
        <h3>1979.09—1981.07，鹤壁师范学校中文专业学习；</h3>
        <h3>1981.07—1985.04，河南省鹤壁市教育局干事、团委副书记；</h3>
        <h3>1985.04—1988.05，河南省鹤壁市委组织部组织科干事、副科级组织员、青干科副科长；</h3>

        <h3>1988.05—1992.11，共青团河南省鹤壁市委副书记、书记、党组书记、市青联主席；</h3>
        <h3>1992.11—1996.03，中共河南省淇县县委副书记、县长、县委书记（1992.02—1993.12 天津大学管理系管理工程专业工商管理方向在职研究生学习）；</h3>
        <h3>1996.03—1997.11，中共河南省鹤壁市委常委、淇县县委书记；</h3>
        <h3>1997.11—2001.03，中共河南省鹤壁市委常委、秘书长，市人民政府常务副市长；</h3>
        <h3>2001.03—2003.12，中共河南省安阳市委常委、市政府常务副市长；</h3>
        <h3>2003.12—2006.12，中共河南省周口市委副书记；</h3>
        <h3>2006.12—2011.12，中共河南省周口市委副书记、市政府市长；</h3>
        <h3>2011.12—2015.04，中共周口市委书记；</h3>
        <h3>2015.04—2017.01，中共周口市委书记、市人大常委会主任；</h3>
        <h3>2017.01—2017.02，河南省人民政府副省长、中共周口市委书记、市人大常委会主任；</h3>
        <h3>2017.02—2017.06，河南省人民政府副省长、周口市人大常委会主任；</h3>
        <h3>2017.06— 河南省人民政府副省长。（简历摘自河南省政府网站，截至2019年8月）</h3>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {
      GoreportInternet() {
      this.$router.push("/Investigate");
    },
    GoreportEvaluation() {
      this.$router.push("/Investigate/DangJi" );
    },
  }
};
</script>

<style lang="less" scoped>
.si{
   margin: 0 16px;
 }
.first {
  text-align: center;
  font-size: 16px;
  color: #999999;
  margin-top: 28px;
  margin-bottom: 30px;
}

.container {
  width: 1200px;
  margin: 0 auto;
}
/*副导航兰*/
.yi {
  margin-top: 20px;
}
.title-tab {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 54px;
  cursor: pointer;
}
.red {
  color: red;
}
/*问卷调查正文*/
.text {
  background-color: white;
  padding: 44px 60px 121px 60px;
  margin: 0 auto;
}
.text h1 {
  font-size: 28px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 56px;
  text-align: center;
}
.text h2 {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 44px;
  text-align: center;
}
.text h3 {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 32px;
  text-indent: 2em;
}
/*静态页面样式 */
.PIC-BOX {
  display: flex;
  justify-content: center;
}
.text h3 b {
  display: block;
  margin-top: 20px;
}
</style>